import { BULLJSJOBNAMES, BULLJSQUEUENAMES } from "@gtpl/shared-models/common-models";
import { InjectQueue } from "@nestjs/bull";
import { Injectable } from "@nestjs/common";
import { Queue } from "bull";

@Injectable()
export class WarehouseJobsService {
    constructor(
        @InjectQueue(BULLJSQUEUENAMES.SAMPLE_JOB) private readonly sampleJob: Queue,
    ) {

    }

    async triggerSampleJob(reqObj: string): Promise<boolean> {
        try {
            await this.sampleJob.add(BULLJSJOBNAMES.SAMPLE_JOB, reqObj);
            return true;
        }   catch (error) {
            throw error;
        }
    }

}